@if (index0) {
  <div class="layout layout--login">
    <div class="layout__login">
      <div class="layout__login-inner">
        <div class="card card--login">
          <div class="card__heading">
            <div class="card__avatar">
              <img src="assets/0/avatar/happy.png" class="img-fluid" alt="">
            </div>
            <h3>{{index0?.header}}</h3>
          </div>
          <div class="card-body">
            <div class="card__form">
              <p [innerHTML]="index0?.body"></p>
            </div>
            <div class="card__btn">
              @if (index0?.buttons?.length) {
                <a href="javascript:;" [routerLink]="'/'+index0?.buttons[0]?.url" class="button button--lg button--primary">{{index0?.buttons[0].button_text}}</a>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
} @else {
<div class="loading-cards" id="loading-cards">
  <div class="loading-cards__list">

    <!-- repeating cards -->
    <div class="loading-cards__card">
      <div class="loading-cards__inner">
        <div class="loading-cards__animation">
          <img src="assets/animations/cards/searching-options.svg" alt="" />
          <!-- <lottie-player src="assets/confetti-discount.json" background="transparent" speed="1" loop></lottie-player> -->
        </div>
        <div class="loading-cards__content">
          <h5 class="font-normal">Considering options</h5>
        </div>
      </div>
    </div>
    <div class="loading-cards__card">
      <div class="loading-cards__inner">
        <div class="loading-cards__animation">
          <img src="assets/animations/cards/calc.svg" alt="" />
          <!-- <lottie-player src="assets/confetti-discount.json" background="transparent" speed="1" loop></lottie-player> -->
        </div>
        <div class="loading-cards__content">
          <h5 class="font-normal">Perfecting premiums</h5>
        </div>
      </div>
    </div>
    <div class="loading-cards__card">
      <div class="loading-cards__inner">
        <div class="loading-cards__animation">
          <img src="assets/animations/cards/insurers-a.svg" alt="" />
          <!-- <lottie-player src="assets/confetti-discount.json" background="transparent" speed="1" loop></lottie-player> -->
        </div>
        <div class="loading-cards__content">
          <h5 class="font-normal">Loading insurers</h5>
        </div>
      </div>
    </div>
    <div class="loading-cards__card">
      <div class="loading-cards__inner">
        <div class="loading-cards__animation">
          <img src="assets/animations/cards/rating.svg" alt="" />
          <!-- <lottie-player src="assets/confetti-discount.json" background="transparent" speed="1" loop></lottie-player> -->
        </div>
        <div class="loading-cards__content">
          <h5 class="font-normal">Adding insurer ratings</h5>
        </div>
      </div>
    </div>
    <div class="loading-cards__card">
      <div class="loading-cards__inner">
        <div class="loading-cards__animation">
          <img src="assets/animations/cards/features-includes.svg" alt="" />
          <!-- <lottie-player src="assets/confetti-discount.json" background="transparent" speed="1" loop></lottie-player> -->
        </div>
        <div class="loading-cards__content">
          <h5 class="font-normal">Packaging the includes and features</h5>
        </div>
      </div>
    </div>
    <div class="loading-cards__card">
      <div class="loading-cards__inner">
        <div class="loading-cards__animation">
          <img src="assets/animations/cards/product-brochure.svg" alt="" />
          <!-- <lottie-player src="assets/confetti-discount.json" background="transparent" speed="1" loop></lottie-player> -->
        </div>
        <div class="loading-cards__content">
          <h5 class="font-normal">Adding product brochures</h5>
        </div>
      </div>
    </div>
    <!-- /repeating cards -->

    <!-- repeating cards -->
    <div class="loading-cards__card">
      <div class="loading-cards__inner">
        <div class="loading-cards__animation">
          <img src="assets/animations/cards/searching-options.svg" alt="" />
          <!-- <lottie-player src="assets/confetti-discount.json" background="transparent" speed="1" loop></lottie-player> -->
        </div>
        <div class="loading-cards__content">
          <h5 class="font-normal">Considering options</h5>
        </div>
      </div>
    </div>
    <div class="loading-cards__card">
      <div class="loading-cards__inner">
        <div class="loading-cards__animation">
          <img src="assets/animations/cards/calc.svg" alt="" />
          <!-- <lottie-player src="assets/confetti-discount.json" background="transparent" speed="1" loop></lottie-player> -->
        </div>
        <div class="loading-cards__content">
          <h5 class="font-normal">Perfecting premiums</h5>
        </div>
      </div>
    </div>
    <div class="loading-cards__card">
      <div class="loading-cards__inner">
        <div class="loading-cards__animation">
          <img src="assets/animations/cards/insurers-a.svg" alt="" />
          <!-- <lottie-player src="assets/confetti-discount.json" background="transparent" speed="1" loop></lottie-player> -->
        </div>
        <div class="loading-cards__content">
          <h5 class="font-normal">Loading insurers</h5>
        </div>
      </div>
    </div>
    <div class="loading-cards__card">
      <div class="loading-cards__inner">
        <div class="loading-cards__animation">
          <img src="assets/animations/cards/rating.svg" alt="" />
          <!-- <lottie-player src="assets/confetti-discount.json" background="transparent" speed="1" loop></lottie-player> -->
        </div>
        <div class="loading-cards__content">
          <h5 class="font-normal">Adding insurer ratings</h5>
        </div>
      </div>
    </div>
    <div class="loading-cards__card">
      <div class="loading-cards__inner">
        <div class="loading-cards__animation">
          <img src="assets/animations/cards/features-includes.svg" alt="" />
          <!-- <lottie-player src="assets/confetti-discount.json" background="transparent" speed="1" loop></lottie-player> -->
        </div>
        <div class="loading-cards__content">
          <h5 class="font-normal">Packaging the includes and features</h5>
        </div>
      </div>
    </div>
    <div class="loading-cards__card">
      <div class="loading-cards__inner">
        <div class="loading-cards__animation">
          <img src="assets/animations/cards/product-brochure.svg" alt="" />
          <!-- <lottie-player src="assets/confetti-discount.json" background="transparent" speed="1" loop></lottie-player> -->
        </div>
        <div class="loading-cards__content">
          <h5 class="font-normal">Adding product brochures</h5>
        </div>
      </div>
    </div>
    <!-- /repeating cards -->

    <div class="loading-cards__card">
      <div class="loading-cards__inner">
        <div class="loading-cards__animation">
          <img src="assets/animations/cards/loading-plans.svg" alt="" />
          <!-- <lottie-player src="assets/confetti-discount.json" background="transparent" speed="1" loop></lottie-player> -->
        </div>
        <div class="loading-cards__content">
          <h5 class="font-normal" id="last-card-text">Nearly there...</h5>
        </div>
      </div>
    </div>
  </div>
  <div class="loading-cards__cta" id="see-prices-btn">
    <a href="javascript:;" (click)="gotToNext()" class="button button--lg button--primary">See prices</a>
  </div>
</div>
}

